import { createAction } from '@reduxjs/toolkit';

import { ParentProgrammeGeneralDetails } from '../../../types/entity.types';
import { SagaPayload } from '../../api.types';
import {
  ArchiveProgrammeRequest,
  ArchiveProgrammeResponse,
  CreateProgrammeRequest,
  CreateProgrammeResponse,
  PublishProgrammeRequest,
  UpdateParentProgrammeRequest,
  UpdateSubProgrammeRequest,
  ViewParentProgrammeRequest,
  ViewSubProgrammeRequest
} from './programme.types';

export const requestViewAllProgrammes = createAction('request/view-all-programmes');

export const requestCreateProgramme =
  createAction<SagaPayload<CreateProgrammeRequest, CreateProgrammeResponse>['payload']>('request/create-programme');

export const requestViewParentProgramme = createAction<
  SagaPayload<ViewParentProgrammeRequest, ParentProgrammeGeneralDetails>['payload']
>('request/view-parent-programme');

export const requestViewSubProgramme =
  createAction<SagaPayload<ViewSubProgrammeRequest>['payload']>('request/view-sub-programme');

export const requestUpdateParentProgramme = createAction<
  SagaPayload<UpdateParentProgrammeRequest, { programmeExternalReference: string }>['payload']
>('request/update-parent-programme');

export const requestUpdateSubProgramme =
  createAction<SagaPayload<UpdateSubProgrammeRequest, { programmeExternalReference: string }>['payload']>(
    'request/update-sub-programme'
  );

export const requestPublishProgramme =
  createAction<SagaPayload<PublishProgrammeRequest, string>['payload']>('request/publish-programme');

export const requestArchiveProgramme =
  createAction<SagaPayload<ArchiveProgrammeRequest, ArchiveProgrammeResponse>['payload']>('request/archive-programme');
